<div class="modal-header">
  <h4 class="modal-title">
    To assist in reuniting the pet with their keeper, you will be asked to share
    your current location and this will be shared with the pet keeper
  </h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="activeModal.dismiss()"
  >
  </button>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-danger text-white"
    ngbAutofocus
    (click)="activeModal.dismiss()"
  >
    Cancel
  </button>
  <button type="button" class="btn btn-success text-white" (click)="confirm()">
    Confirm
  </button>
</div>
